// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2c-6";
export var headerCell = "_2c-2";
export var loadingStateContent = "_2c-8";
export var rowWrapper = "_2c-4";
export var stickyAggregationCell = "_2c-b";
export var stickyAggregationRow = "_2c-7";
export var stickyColumnCell = "_2c-a";
export var stickyColumnHeaderCell = "_2c-9";
export var table = "_2c-1";
export var virtualRowWrapper = "_2c-5";
export var virtualTableContainer = "_2c-0";
export var white = "_2c-3";